module.exports = __webpack_public_path__ + "static/hawaii-3-ca2bfa88ff82d20aa24d21654f121000.png";